<script>
    import WPNItemsTable from "./WPNItemsTable.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { associatedItemsForEntities } from "../../scripts/wpn2Model.js";

    export let item;
    export let entities;
    export let cellButtonTypes;
    let relatedItems;

    $: relatedItems = associatedItemsForEntities(entities, $dbData.all, item, true, true, true, true);

</script>

{#if relatedItems.length > 0}
    <div class="detail-section">
        <div class="detail-section-title">Related Items</div>
        <div class="table-container">
            <WPNItemsTable
                items={relatedItems}
                {cellButtonTypes}
                on:item-select
                on:find-on-map
                on:item-remove
                on:item-add
            />
        </div>
    </div>
{/if}
